import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { progressActions } from '@app/store/progress/actions/progress.actions';
import { reflectionActions } from '../actions/reflection.actions';

@Injectable({
    providedIn: 'root',
})
export class Reflection_ProgressBridge {
    private readonly actions = inject(Actions);

    onSubmitReflectionGetProgress$ = createEffect(() => {
        return this.actions.pipe(
            ofType(reflectionActions.submitReflectionSuccess),
            map(() => progressActions.getProgress()),
        );
    });

    refetchAffectedProgress$ = createEffect(() => {
        return this.actions.pipe(
            ofType(reflectionActions.submitReflectionSuccess),
            map(({ payload: { moduleIds, courseIds, pathwayIds } }) => progressActions.resetCachedProgressEntries({ courseIds, moduleIds, pathwayIds })),
        );
    });
}
